import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ClosureApproveRequestWidget from '../../../widgets/durableArticlesWidget/projectClosingRequest/ClosureApproveRequestWidget'
import { getAssetClosureApprove } from '../../../redux/actions/accountingAssetClosure'
import { sessionRemoveItem } from '../../../utils/sessionHelpers'
//จัดการขอปิด นักวิชาการ , ผอ.สำนัก , จทน พัสดุ , ผอ.สำนัก
export default function ClosureApproveRequest({ step }) {
  console.log('step ** ', step)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    sessionRemoveItem('assetClosureStep')
    sessionRemoveItem('assetClosureId')
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAssetClosureApprove(step, 1, 5)

      setSchema(response.model)
      //setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />
        <ClosureApproveRequestWidget
          schema={schema.form}
          isViewMode={schema.disabled}
          step={step}
        />
        <br />
      </SidebarProposal>
    </div>
  )
}
